$(() => {
  $(document).ready(function() {
    if (location.hash === "#api-key") {
      $("html,body").scrollTop(0);
    }

    $("#api-docs-nav .nav-link").on("click", function(event) {
      event.preventDefault()
      let anchor = $(event.target).attr("href")

      history.replaceState({}, "", anchor)
      $("#docs").animate({
          scrollTop: $(anchor)[0].offsetTop
      }, 1000)
    })
  });

  $("#api-docs-nav .nav-link").on("click", function(event) {
    event.preventDefault()
    let anchor = $(event.target).attr("href")

    history.replaceState({}, "", anchor)
    $("#docs").animate({
        scrollTop: $(anchor)[0].offsetTop
    }, 1000)
  })

  $("#docs").on("activate.bs.scrollspy", function (e) {
    history.replaceState({}, "", $("#api-docs-nav .nav-link.active").attr("href"))
  })
});
